import { render, staticRenderFns } from "./TheZigZag.vue?vue&type=template&id=00fe24b1&"
import script from "./TheZigZag.vue?vue&type=script&lang=js&"
export * from "./TheZigZag.vue?vue&type=script&lang=js&"
import style0 from "./TheZigZag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports